import { nullableSchema, objectSchema } from "vue-utils"
import type { Nullable } from "../IncidentEntity"

export interface ShipRegistration {
	portOfRegistry: Nullable<string>
	homePort: Nullable<string>
	ownerName: Nullable<string>
	ownerAddress: Nullable<string>
}

export const ShipRegistration = objectSchema<ShipRegistration>({
	portOfRegistry: nullableSchema(String),
	homePort: nullableSchema(String),
	ownerName: nullableSchema(String),
	ownerAddress: nullableSchema(String),
})
